import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {AdminComponent} from './admin/admin.component';
import {authManager} from './helpers/authManager';
import {ExternalUserComponent} from './external-user/external-user.component';
import {InvoiceDetailsComponent} from './external-user/invoice-details/invoice-details.component';
import { OrderDetailsComponent } from './external-user/order-details/order-details.component';
import {AdvanceDetailsComponent} from './external-user/advance-details/advance-details.component';
import {LandingComponent} from './landing.component';
import {HeaderComponent} from './header/header.component';
import { BrowserModule } from '@angular/platform-browser';
import {RefundApproveComponent} from './refund-approve/refund-approve.component';
import { ExternalloginComponent } from './externallogin/externallogin.component';
import { ExternalRegistrationComponent } from './external-registration/external-registration.component';
import {AccountExecutiveComponent} from './account-executive/account-executive.component';
import { ExternalChangePassword } from './externalchangepassword/externalchangepassword.component';
import {ExternalForgotPasswordComponent} from './external-forgot-password/external-forgot-password.component';
import { AdvancePaymentStatusComponent } from './external-user/advance-details/advance-payment-status/advance-payment-status.component';
import { OrderInvoiceDetailsComponent } from './external-user/order-invoice-details/order-invoice-details.component';
import { OrderInvoiceStatusComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status.component';
import { RefundStatusComponent } from './refund-approve/refund-status/refund-status.component';
import { ChaseGatewayComponent } from './chase-gateway/chase-gateway.component';
import { InvoiceStatusComponent } from './external-user/invoice-details/invoice-status/invoice-status.component';
import { OrderStatusComponent } from './external-user/order-details/order-status/order-status.component';
import { InvoiceStatusProfileComponent } from './external-user/invoice-details/invoice-status/invoice-status-profile/invoice-status-profile.component';
import { OrderInvoiceStatusProfileComponent } from './external-user/order-invoice-details/order-invoice-status/order-invoice-status-profile/order-invoice-status-profile.component';
import { OrderStatusProfileComponent } from './external-user/order-details/order-status/order-status-profile/order-status-profile.component';
import { AdvancePaymentStatusProfileComponent } from './external-user/advance-details/advance-payment-status/advance-payment-status-profile/advance-payment-status-profile.component';
import {InternalinvoiceComponent} from './internalinvoice/internalinvoice.component';
import { UserTypeGuard } from './user-type.guard';
import { ChaseTransactionLogsComponent} from './chase-transaction-logs/chase-transaction-logs.component';
//   Agency
import { AgencyComponent } from './admin/agency/agency.component';
const routes: Routes = [
// App routes goes here here

{ path: '', component:LandingComponent, canActivate: [authManager] },
{ path: 'Admin',component: AdminComponent, canActivate: [UserTypeGuard]},
{ path: 'Invoice',component: ExternalUserComponent, canActivate: [UserTypeGuard]},
{ path: 'Invoice/:isOderDeatails',component: ExternalUserComponent},
//{ path: 'invoiceDetail/:totalamount/:selectedInvoiceID',component: InvoiceDetailsComponent},
{ path: 'InvoiceDetail/:chaseOrderId',component: InvoiceDetailsComponent},
{ path: 'OrderDetail/:chaseOrderId',component: OrderDetailsComponent},
{ path: 'AdvanceDetail/:chaseOrderId',component: AdvanceDetailsComponent},
{ path: 'Header',component: HeaderComponent},
{ path: 'RefundApprove',component: RefundApproveComponent, canActivate: [UserTypeGuard]},
{ path: 'Login',component: ExternalloginComponent},
{ path: 'Registration',component: ExternalRegistrationComponent},
{ path: 'TransactionRefund',component: AccountExecutiveComponent},
{ path: 'ChangePassword',component: ExternalChangePassword},
{ path: 'ChangePasswordOnForgotPassword',component: ExternalChangePassword},
{ path: 'ForgotPassword',component: ExternalForgotPasswordComponent},
{ path: 'AdvancePaymentStatus', component: AdvancePaymentStatusComponent },
{ path: 'OrderInvoiceDetail/:chaseOrderId', component: OrderInvoiceDetailsComponent },
{ path: 'OrderInvoiceStatus', component: OrderInvoiceStatusComponent },
{ path: 'RefundStatus/:chaseOrderId', component: RefundStatusComponent },
{ path: 'MediaPayPayment/:transactionType/:paymentType/:chaseOrderId', component: ChaseGatewayComponent },
{ path: 'InvoiceStatus', component: InvoiceStatusComponent },
{ path: 'OrderStatus', component: OrderStatusComponent },
{ path: 'InvoiceStatusProfile/:chaseOrderId/:status', component: InvoiceStatusProfileComponent },
{ path: 'OrderInvoiceStatusProfile/:chaseOrderId/:status', component: OrderInvoiceStatusProfileComponent },
{ path: 'OrderStatusProfile/:chaseOrderId/:status', component: OrderStatusProfileComponent },
{ path: 'AdvancePaymentStatusProfile/:chaseOrderId/:status', component: AdvancePaymentStatusProfileComponent },
{ path: 'InternalInvoice', component: InternalinvoiceComponent },
{ path: 'ChaseTransaction', component: ChaseTransactionLogsComponent },
//   Add Agency
{ path: 'agency', component:AgencyComponent},

];

@NgModule({
   exports: [ RouterModule ],
  imports: [RouterModule.forRoot(routes,{ useHash: true }),
    CommonModule
  ],
  declarations: []
})
export class AppRoutingModule { }